import {EntityApiService, ApiClientService} from '@dofleini/security';

class ClientsApiService extends EntityApiService {

    getOneClient = ({clientId}, params) => {
      const config = {params};
      if (params?.projections && Array.isArray(params.projections)) {
        config.params = {
          ...params,
          projections: params.projections.join(',')
        };
      }
      return ApiClientService.get(this.getPath(`/${clientId}`), config);
    };

    delete = ({_id}) => ApiClientService.delete(this.getPath(`/${_id}?cascadeDelete=true`));

    setEstablishmentId = (currentId) => {
      localStorage.setItem('establishment-current-id', currentId);
    }

    getEstablishmentId = () => {
      return localStorage.getItem('establishment-current-id');
    }

    searchForUsers = (params) => ApiClientService.post(this.getPath('/search-for-client-users'), params);
}

export default new ClientsApiService('/ms-core/api/establishments');
